import { Button, Grid, Stack } from '@mui/material';
import { dashboardGridColumn, dashboardGridContainer } from './OverlayDissolveValues';
import { useTranslation } from 'react-i18next';

export function OverlayDissolveDetailEmpty({
  onSave,
  requestApplication,
}: {
  onSave?: () => Promise<void>;
  requestApplication?: () => Promise<void>;
}) {
  const { t } = useTranslation();

  return (
    <Grid container {...dashboardGridContainer} key="empty">
      <Grid {...dashboardGridColumn}></Grid>
      <Grid {...dashboardGridColumn}>
        <Stack gap={1}>
          <Stack flexDirection="row-reverse" gap={2}>
            <Button variant="contained" onClick={requestApplication}>
              {t('dashboard.contractsOverlay.dissolveValues.requestApplication')}
            </Button>
            <Button variant="outlined" color="secondary" onClick={onSave}>
              {t('save')}
            </Button>
          </Stack>
        </Stack>
      </Grid>
    </Grid>
  );
}
